import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-nebula-angular',
  template: `
    <p>
      nebula-angular works!
    </p>
  `,
  styles: []
})
export class NebulaAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
